@if (data(); as msg) {
    Updated <program-item [program]="msg.program" />
}
 